import React from 'react';
import { Heart } from 'lucide-react';

const SocialProofSection = () => {
  const testimonials = [
    {
      name: 'Ananya Desai',
      location: 'Mumbai',
      text: 'The attention to detail in every gift is extraordinary. Guriva transformed my wedding favors into memorable experiences.',
      rating: 5,
    },
    {
      name: 'Rohan Khanna',
      location: 'Gurugram',
      text: 'Perfect for corporate gifting. Our clients were impressed by the thoughtful curation and premium quality.',
      rating: 5,
    },
    {
      name: 'Divya Menon',
      location: 'Bangalore',
      text: 'Ordered for Diwali - the presentation was stunning! Each piece felt personal and luxurious.',
      rating: 5,
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif text-neutral-800 mb-4 tracking-wide">
            Loved by Gift Enthusiasts
          </h2>
          <p className="text-neutral-600">Stories from our community</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-neutral-50 p-8 border border-neutral-200 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Heart key={i} className="w-4 h-4 fill-amber-600 text-amber-600" />
                ))}
              </div>
              <p className="text-neutral-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              <div className="border-t border-neutral-200 pt-4">
                <p className="font-medium text-neutral-800">{testimonial.name}</p>
                <p className="text-sm text-neutral-600">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
